
import { Component, Mixins, Prop } from "vue-property-decorator";
import { VuetifyMixin, AppHostnameMixin, StringsMixin, AthleteTeamScheduleMixin, SocialMediaMixin, BAIconsMixin, AthleteRoutingMixin, ColorMixin, AuthMixin } from "@/mixins";

import TeamMiniCard from "@/components/ui/TeamMiniCard.vue";
import RecruitingProfileInfoProvider from "@/components/hoc/RecruitingProfileInfoProvider.vue";
import AthleteHighlightReelCard from "@/components/profile/athlete/AthleteHighlightReelCard.vue";
import AthleteScheduleCard from "@/components/profile/athlete/AthleteScheduleCard.vue";
import AthleteVerifiedAssessmentsCard from "@/components/profile/athlete/AthleteVerifiedAssessmentsCard.vue";
import AthleteMindsetReportCard from "@/components/profile/athlete/AthleteMindsetReportCard.vue";
import AthleteScoutingReportsCard from "@/components/profile/athlete/AthleteScoutingReportsCard.vue";
import AthleteSelfAssessmentsCard from "@/components/profile/athlete/AthleteSelfAssessmentsCard.vue";
import AthleteEducationCard from "@/components/profile/athlete/AthleteEducationCard.vue";
import { athleteProfile as athleteProfileStore, notificationStore } from '@/store';

import { AthleteTeamDashboard, AthleteComparativeDataSummary, TeamDashboard } from "@/../types/constants/web_client_user.routes";
import { AthleteMetric } from '@best-athletes/ba-types';

import { BARatingFormula, TeamModel } from '@/models'
import { baRatingFormulaApi } from '@/api/BARatingFormulaApi';

@Component({
	components: {
		RecruitingProfileInfoProvider,
		TeamMiniCard,
		AthleteHighlightReelCard,
		AthleteScheduleCard,
		AthleteVerifiedAssessmentsCard,
		AthleteMindsetReportCard,
		AthleteScoutingReportsCard,
		AthleteSelfAssessmentsCard,
		AthleteEducationCard,
	}
})
export default class RecruitingProfileCard extends Mixins(VuetifyMixin, AppHostnameMixin, AuthMixin, StringsMixin, ColorMixin, AthleteRoutingMixin, AthleteTeamScheduleMixin, SocialMediaMixin, BAIconsMixin) {
	// inherited from AthleteTeamScheduleMixin
	// @Prop({ required: true }) athleteProfile: AthleteProfileModel;
	@Prop({ default: null }) sharingUrlId: string | null;

	mounted(): void {
		if( this.IsAdmin ) this.loadActiveFormula();
		if( !this.publicView ) this.loadTeamEvents();
	}

	formula: BARatingFormula;
	isFormulaLoaded: boolean = false;
	async loadActiveFormula() {
		this.isFormulaLoaded = false;
		if( !this.IsAdmin || this.IsAthlete ) return;

		this.formula = await baRatingFormulaApi.findActive();
		this.isFormulaLoaded = true;
	}

	showHelp: boolean = false;

	get IsAthleteViewHelp(): boolean {
		return this.AthleteAppActive && this.showHelp;
	}
	get ShowContactInfo(): boolean {
		return this.IsAthleteViewHelp || this.athleteProfile.shareContact;
	}
	get ShowEducation(): boolean {
		return this.IsAthleteViewHelp || this.athleteProfile.shareEducation;
	}
	get ShowBaseInfo(): boolean {
		return this.IsAthleteViewHelp || this.athleteProfile.shareBaseInfo;
	}
	get ShowAbout(): boolean {
		return this.IsAthleteViewHelp || this.athleteProfile.shareAbout;
	}
	get ShowClubHistory(): boolean {
		return this.IsAthleteViewHelp || this.athleteProfile.shareClubHistory;
	}
	get ShowHighlights(): boolean {
		if( this.IsAthleteViewHelp ) return true;
		return( this.athleteProfile.isVisible('highlightDetails') && this.athleteProfile.hasVideos )
	}
	get ShowWeblinks(): boolean {
		if( this.IsAthleteViewHelp ) return true;
		return( this.athleteProfile.isVisible('weblinks') && this.IsNotEmpty(this.athleteProfile.weblinks) )
	}
	get ShowSchedule(): boolean {
		if( !this.teamEventsInitialized ) return false;
		if( this.IsAthleteViewHelp ) return true;
		if( !this.athleteProfile.isVisible('schedule') ) return false;
		return( this.athleteProfile.hasFutureSchedule() || this.HasFutureTeamEvents )
	}
	ShowData(key: string, dataAvailable: boolean): boolean {
		if( key.toLowerCase().includes('self') && !this.athleteProfile.Sport.IsSoccer ) return false;
		if( this.IsAthleteViewHelp ) return true;
		return( dataAvailable && this.athleteProfile.isVisible(key));
	}
	
	onEdit(step: string) {
		this.$emit('editmode', step);
	}

	viewTeam(team: TeamModel) {
		if( this.IsEmpty(team?.id) ) return;

		if( this.AthleteAppActive ) {
			this.$router.push({
				name: AthleteTeamDashboard,
				params: {
					teamId: team.id,
				}
			});
		} else {
			this.$router.push({
				name: TeamDashboard,
				params:{
					teamId: team.id,
				}			
			})
		}
	}	

	onViewComparativeData(metric: AthleteMetric): void{
		// view the comparative data for the specified metric for this athlete
		this.$router.push({
			name: AthleteComparativeDataSummary,
			params:{
				metric,
				athleteId: this.athleteProfile.id,
			}
		});
		// go to the top of the page
		this.$vuetify.goTo(0);
	}

	async updateProfileVisibility(setting: string) {
		this.athleteProfile.profileVisibility.recruiter[setting] = true;
		await athleteProfileStore.patchAthleteProfile({
				patch: {
					id: this.athleteProfile.id,
					profileVisibility: this.athleteProfile.profileVisibility,
				},
			});
		notificationStore.snackbarChangesSavedSuccess();
	}
}
